<!-- DON'T add a routerLink property to the a-element. Thank you! -->
<a
  class="asset-nav-button body-bold"
  [class.disconnected]="
    !connected() && !criticalStatus() && !warningStatus() && !inactiveStatus()
  "
  [class.working]="
    cfg.appName === 'em'
      ? connected() && !warning() && !critical() && !inActive() && !isArchived()
      : working()
  "
  [class.warning]="
    (warning() && !inActive() && !isArchived()) || warningStatus()
  "
  [class.critical]="
    (connected() && critical() && !inActive() && !isArchived()) ||
    criticalStatus()
  "
  [class.inactive]="(inActive() && !isArchived()) || inactiveStatus()"
  [class.disabled]="disabled()"
  [class.greyOut]="greyOut()"
  [class.blackBG]="blackBG()"
  [class.blackCoral]="cfg.appName === 'em' ? blackCoral() : false"
  [class.IsArchived]="isArchived()"
  [class.blackBorder]="blackBorder()"
  role="link"
  (click)="onClick($event)"
>
  <div class="asset-nav-button-content" [class.no-icon]="!show_icon()">
    @if (svg_icon() && show_icon()) {
      <i
        nz-icon
        [nzType]="svg_icon()"
        class="svg-icon"
        [class.fillgrey]="!!asset() && !connected() && !blackCoral()"
        [class.fillgreen]="
          !!asset() &&
          !inActive() &&
          !isArchived() &&
          !!connected() &&
          !warning() &&
          !critical() &&
          !inActive() &&
          !blackBG() &&
          !blackCoral()
        "
        [class.fillblack]="cfg.appName === 'ia' && blackCoral()"
        [class.fillwhite]="
          cfg.appName === 'em'
            ? (!asset() && !warningStatus()) ||
              (!isArchived() &&
                !!connected() &&
                (!warning() ||
                  !!critical() ||
                  !!inActive() ||
                  blackBG() ||
                  blackCoral()))
            : !working() || blackBG()
        "
        aria-hidden="true"
      ></i>
    }

    <span class="amountwrapper">
      <span>
        <ng-content></ng-content>
      </span>

      @if (amount()) {
        <span class="amount"> ({{ amount() }})</span>
      }
    </span>

    @if (svg_icon_right()) {
      <i
        nz-icon
        [nzType]="svg_icon_right()"
        [class.fillwhite]="
          !asset() ||
          (!!connected() && !warning() && !!critical() && !isArchived()) ||
          (!!inActive() && !isArchived())
        "
        [class.fillgrey]="
          cfg.appName === 'ia' ? greyOut() : !!asset() && !connected()
        "
        [class.fillblack]="
          (!!asset() &&
            !!connected() &&
            !greyOut() &&
            !warning() &&
            !critical() &&
            !inActive()) ||
          (isArchived() && connected())
        "
        class="svg-icon right-icon"
      ></i>
    }
  </div>
</a>
